import { ReactElement } from 'react';
import { Body, Content } from './Layout.elements';
import { Menu } from '../Menu';
import { Theme } from '../../theme';
import { ThemeChanger } from '../ThemeChanger';

type Props = {
  children: ReactElement;
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const Layout = ({ children, theme, setTheme }: Props): ReactElement => {
  return (
    <Body>
      <Menu />
      <Content>{children}</Content>
      <ThemeChanger theme={theme} setTheme={setTheme} />
    </Body>
  );
};
